import { File } from "@/type/core/dashboard/dashboard.types";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import ImportFilesCard from "@components/core/cards/ImportFilesCard";
import BasicModal, {
  BasicModalProps,
} from "@components/core/modals/BasicModal";

interface ImportContactModalProps extends BasicModalProps {
  onFilesChange: (files: File[]) => void;
}

const ImportContactModal: FunctionComponent<ImportContactModalProps> = ({
  onFilesChange,
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <BasicModal
      title={t("contacts.importContacts")}
      footerTakeAllWidth
      {...props}
    >
      <div className="import-contact-modal-container">
        <span>{t("contacts.importContactsDescription")}</span>
        <a
          className="example-import"
          href="/files/import-contacts-exemple.xlsx"
          download
        >
          {t("contacts.example")}
        </a>
        <ImportFilesCard
          className="import-files-card"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          description={t("contacts.importModal.importDescription")}
          title={t("contacts.importModal.importDescription")}
          descriptionSeparator={t("contacts.importModal.descriptionSeparator")}
          extensions={["xlsx", "xls"]}
          name={"contactCardItem"}
          descriptionUrlTitle={t("contacts.importModal.descriptionUrlTitle")}
          setFiles={onFilesChange}
          url="#"
          openFilesSelectionOnClick
        />
      </div>
    </BasicModal>
  );
};

export default ImportContactModal;
